/**
 * San Valentín Bundle - OK Perfumes
 * v9.1 - Con fixes CRO aplicados
 */
(function() {
  'use strict';

  const CFG = window.SVConfig || {};
  
  const PACKS = {
    'dulces-masc': ['OMX', 'LMX', 'SWI', 'UTM', 'SCU', 'AÏR', 'SBX', 'VUM', 'TBV', 'NIS'],
    'dulces-fem': ['VEB', 'SCD', 'ANM', 'DVO', 'TOO', 'CHA', 'BRG', 'LNT', 'YRC', 'BIA'],
    'frescos-masc': ['ADG', 'ASP', 'BLC', 'CWT', 'ERS', 'KPH', 'SVG', 'IVS', 'DGI', 'PLB'],
    'florales-fem': ['CLE', 'JDR', 'MWY', 'IDL', 'FGG', 'GUB', 'BCV', 'ETF', 'AOM', 'LEM'],
    'amaderados': ['OWO', 'SAT', 'BAF', 'BDA', 'AXJ', 'BTF', 'TBV', 'ELW', 'ONM', 'ACD'],
    'unisex-top': ['LYT', 'BRG', 'EPX', 'KAS', 'NIS', 'TKL', 'ONM', 'ACD', 'ITL', 'NEF']
  };

  let PERFUMES = [];
  let MUESTRAS = [];
  
  const state = {
    perfumes: [null, null],
    muestras: [],
    activePack: null,
    muestrasQty: 10,
    muestrasValue: 30,
    loaded: false,
    celebrated: false
  };

  const $ = sel => document.querySelector(sel);
  const $$ = sel => document.querySelectorAll(sel);
  const fmt = n => n.toFixed(2).replace('.', ',') + ' €';
  const gLabel = g => ({ M: 'Él', F: 'Ella', U: 'Unisex' }[g] || '');
  const gClass = g => ({ M: 'm', F: 'f', U: 'u' }[g] || 'u');
  const norm = s => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  function getTramo() {
    const now = new Date();
    const t1End = new Date(CFG.tramo1End || '2026-02-10');
    t1End.setHours(23, 59, 59, 999);
    if (now <= t1End) {
      return { qty: CFG.muestrasT1 || 10, value: (CFG.muestrasT1 || 10) * (CFG.precioMuestra || 3), deadline: t1End, deadlineText: '10 de febrero' };
    }
    return { qty: CFG.muestrasT2 || 6, value: (CFG.muestrasT2 || 6) * (CFG.precioMuestra || 3), deadline: new Date(CFG.tramo2End || '2026-02-14'), deadlineText: '14 de febrero' };
  }

  async function loadProducts() {
    const url = CFG.productsUrl;
    if (!url) { console.error('SVBundle: No productsUrl'); return false; }
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      PERFUMES = await res.json();
      MUESTRAS = PERFUMES.map(p => ({ c: p.c, i: p.i, m: p.m, g: p.g, f: p.f }));
      console.log(`SVBundle v9.1: ${PERFUMES.length} productos`);
      return true;
    } catch (err) { console.error('SVBundle: Error', err); return false; }
  }

  function initTramoUI() {
    const tramo = getTramo();
    state.muestrasQty = tramo.qty;
    state.muestrasValue = tramo.value;
    const updates = {
      'header-muestras-qty': tramo.qty, 
      'header-gift-value': tramo.value + '€',
      'step-muestras-qty': tramo.qty, 
      'step-gift-value': tramo.value + '€',
      'sum-muestras-qty': tramo.qty, 
      'price-gift': fmt(tramo.value),
      'price-save': '–' + fmt(tramo.value), 
      'faq-gift-value': tramo.value + '€',
      'sticky-muestras-qty': tramo.qty, 
      'deadline-text': tramo.deadlineText,
      'sum-deadline': tramo.deadlineText
    };
    Object.entries(updates).forEach(([id, val]) => { const el = document.getElementById(id); if (el) el.textContent = val; });
    $$('.max-qty').forEach(el => el.textContent = tramo.qty);
    initCountdown(tramo.deadline);
  }

  function initCountdown(endDate) {
    function update() {
      const diff = endDate - new Date();
      if (diff <= 0) return;
      const d = Math.floor(diff / 86400000), h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
      ['cd-d', 'cd-h', 'cd-m', 'cd-s'].forEach((id, i) => {
        const el = document.getElementById(id);
        if (el) el.textContent = [d, h, m, s][i].toString().padStart(2, '0');
      });
    }
    update(); setInterval(update, 1000);
  }

  function getPacksLeft() {
    const now = new Date();
    const tramo1Start = new Date('2026-02-06');
    const tramo1End = new Date('2026-02-10');
    const tramo2End = new Date('2026-02-14');
    
    tramo1End.setHours(23, 59, 59, 999);
    tramo2End.setHours(23, 59, 59, 999);
    
    if (now <= tramo1End) {
      // Tramo 1: de 1000 a 200 en 10 días
      const totalMs = tramo1End - tramo1Start;
      const elapsedMs = now - tramo1Start;
      const progress = Math.min(1, Math.max(0, elapsedMs / totalMs));
      return Math.round(1000 - (progress * 800));
    } else if (now <= tramo2End) {
      // Tramo 2: de 200 a 50 en 4 días
      const totalMs = tramo2End - tramo1End;
      const elapsedMs = now - tramo1End;
      const progress = Math.min(1, Math.max(0, elapsedMs / totalMs));
      return Math.round(200 - (progress * 150));
    }
    return 50;
  }

  function updatePacksDisplay() {
    const packs = getPacksLeft();
    const elements = ['packs-left', 'urgency-packs'];
    elements.forEach(id => {
      const el = document.getElementById(id);
      if (el) el.textContent = packs;
    });
  }

  function search(list, query, filter) {
    let results = [...list];
    if (filter) {
      const [type, val] = filter.split(':');
      if (type === 'g') results = results.filter(p => p.g === val);
      else if (type === 'f') results = results.filter(p => p.f?.some(f => f === val));
    }
    if (query && query.length >= 1) {
      const q = norm(query);
      results = results.filter(p => norm(p.c).includes(q) || norm(p.i).includes(q) || norm(p.m).includes(q) || (p.f && p.f.some(f => norm(f).includes(q))));
    }
    return results.slice(0, 20);
  }

  function renderResults(container, results, type, isInitial) {
    if (!results.length) { 
      container.innerHTML = '<div class="sv-no-results">Sin resultados</div>'; 
      return; 
    }
    const headerHtml = isInitial ? '<div class="sv-results-header">🔥 Más populares</div>' : '';
    const closeBtn = window.innerWidth < 640 ? '<button type="button" class="sv-results-close">✕ Cerrar</button>' : '';
    
    container.innerHTML = headerHtml + results.map(p => `
      <div class="sv-result" data-code="${p.c}">
        <span class="sv-result-code">${p.c}</span>
        <div class="sv-result-info">
          <div class="sv-result-name">${p.i || p.c}</div>
          <div class="sv-result-meta">${p.m || ''} ${gLabel(p.g) ? '· ' + gLabel(p.g) : ''}</div>
        </div>
        <span class="sv-result-tag ${gClass(p.g)}">${gLabel(p.g)}</span>
        ${type === 'perfume' && p.p ? `<span class="sv-result-price">${fmt(p.p)}</span>` : ''}
      </div>
    `).join('') + closeBtn;
    
    const closeBtnEl = container.querySelector('.sv-results-close');
    if (closeBtnEl) {
      closeBtnEl.onclick = (e) => {
        e.stopPropagation();
        container.classList.remove('active');
      };
    }
  }

  function selectPerfume(code) {
    const perfume = PERFUMES.find(p => p.c === code);
    if (!perfume) return;
    const slot = state.perfumes.findIndex(p => !p);
    state.perfumes[slot !== -1 ? slot : 1] = perfume;
    renderPerfumes(); updateAll();
    if (state.perfumes[0] && state.perfumes[1]) $('#step-muestras')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function removePerfume(idx) { state.perfumes[idx] = null; renderPerfumes(); updateAll(); }

  function renderPerfumes() {
    state.perfumes.forEach((p, i) => {
      const slot = $(`#slot-${i}`);
      if (!slot) return;
      if (!p) {
        slot.className = 'sv-slot empty';
        slot.innerHTML = i === 0 
          ? `💕 ¿Para él o para ella? Elige el primero`
          : `💕 Ahora elige el segundo perfume`;
        slot.onclick = () => $('#perfume-search')?.focus();
      } else {
        slot.className = 'sv-slot filled';
        slot.innerHTML = `
          <span class="sv-slot-code">${p.c}</span>
          <div class="sv-slot-info"><div class="sv-slot-name">${p.i || p.c}</div><div class="sv-slot-meta">${p.m || ''} · ${gLabel(p.g)}</div></div>
          <span class="sv-slot-price">${fmt(p.p)}</span>
          <button type="button" class="sv-slot-remove" data-idx="${i}">×</button>
        `;
        slot.onclick = null;
        slot.querySelector('.sv-slot-remove').onclick = e => { e.stopPropagation(); removePerfume(i); };
      }
    });
    const count = state.perfumes.filter(p => p).length;
    const status = $('#perfumes-status');
    if (status) { status.textContent = `${count}/2`; status.classList.toggle('complete', count === 2); }
  }

  function selectMuestra(code) {
    if (state.muestras.length >= state.muestrasQty) { showToast(`Ya tienes ${state.muestrasQty} muestras`); return; }
    const muestra = MUESTRAS.find(m => m.c === code);
    if (!muestra) return;
    state.muestras.push(muestra); state.activePack = null;
    updatePackButtons(); renderMuestras(); updateAll();
  }

  function removeMuestra(idx) {
    state.muestras.splice(idx, 1); state.activePack = null;
    updatePackButtons(); renderMuestras(); updateAll();
  }

  function renderMuestras() {
    const box = $('#muestras-box'), counter = $('#muestras-counter'), status = $('#muestras-status');
    if (!state.muestras.length) {
      box.innerHTML = '<span class="sv-muestras-empty">Busca muestras o elige un pack rápido ↓</span>';
      box.classList.remove('has-items');
    } else {
      box.innerHTML = state.muestras.map((m, i) => `
        <div class="sv-chip" tabindex="0">
          <span class="sv-chip-code">${m.c}</span>
          <span class="sv-chip-name">${m.i || ''}</span>
          <button type="button" class="sv-chip-remove" data-idx="${i}">×</button>
          <div class="sv-chip-tooltip">${m.i} · ${m.m || ''}</div>
        </div>
      `).join('');
      box.classList.add('has-items');
      box.querySelectorAll('.sv-chip-remove').forEach(btn => { 
        btn.onclick = e => { e.stopPropagation(); removeMuestra(+btn.dataset.idx); }; 
      });
    }
    const countText = `${state.muestras.length}/${state.muestrasQty}`;
    if (counter) { counter.textContent = countText; counter.classList.toggle('complete', state.muestras.length === state.muestrasQty); }
    if (status) { status.textContent = countText; status.classList.toggle('complete', state.muestras.length === state.muestrasQty); }
  }


  function selectPack(packId) {
    const codes = PACKS[packId];
    if (!codes) return;
    state.muestras = []; state.activePack = packId;
    codes.forEach(code => {
      if (state.muestras.length >= state.muestrasQty) return;
      const m = MUESTRAS.find(x => x.c === code);
      if (m && !state.muestras.some(x => x.c === code)) state.muestras.push(m);
    });
    if (state.muestras.length < state.muestrasQty) {
      const available = MUESTRAS.filter(m => !state.muestras.some(x => x.c === m.c)).sort(() => Math.random() - 0.5);
      state.muestras.push(...available.slice(0, state.muestrasQty - state.muestras.length));
    }
    updatePackButtons(); renderMuestras(); updateAll(); showToast('✨ Pack aplicado');
  }

  function selectRandomMuestras() {
    if (state.muestras.length >= state.muestrasQty) { showToast('Ya tienes todas las muestras'); return; }
    const faltantes = state.muestrasQty - state.muestras.length;
    const shuffled = [...MUESTRAS].sort(() => Math.random() - 0.5);
    state.muestras.push(...shuffled.slice(0, faltantes));
    state.activePack = null;
    updatePackButtons(); renderMuestras(); updateAll(); 
    showToast(`🎲 +${faltantes} muestras añadidas`);
  }

  function updatePackButtons() { $$('.sv-pack').forEach(btn => btn.classList.toggle('active', btn.dataset.pack === state.activePack)); }

  function updateProgress() {
    const perfumesDone = state.perfumes[0] && state.perfumes[1];
    const muestrasDone = state.muestras.length === state.muestrasQty;
    const allDone = perfumesDone && muestrasDone;
    let percent = 0;
    if (state.perfumes[0]) percent += 25;
    if (state.perfumes[1]) percent += 25;
    percent += (state.muestras.length / state.muestrasQty) * 50;
    percent = Math.min(100, Math.round(percent));
    const fill = $('#progress-fill'); if (fill) fill.style.width = `${percent}%`;
    const status = $('#progress-status'); if (status) { status.textContent = allDone ? '¡Completado!' : `${percent}%`; status.classList.toggle('complete', allDone); }
    const step1 = $('#prog-step-1'); if (step1) { step1.classList.toggle('done', perfumesDone); step1.classList.toggle('active', !perfumesDone); }
    const step2 = $('#prog-step-2'); if (step2) { step2.classList.toggle('done', muestrasDone); step2.classList.toggle('active', perfumesDone && !muestrasDone); }
    const step3 = $('#prog-step-3'); if (step3) { step3.classList.toggle('done', allDone); }
    const stepP = $('#step-perfumes'); if (stepP) { stepP.classList.toggle('active', !perfumesDone); stepP.classList.toggle('complete', perfumesDone); }
    const stepM = $('#step-muestras'); if (stepM) { stepM.classList.toggle('active', perfumesDone && !muestrasDone); stepM.classList.toggle('complete', muestrasDone); }
  }

  function updateSummary() {
    const sumP1 = $('#sum-p1'), sumP2 = $('#sum-p2');
    if (sumP1) sumP1.textContent = state.perfumes[0] ? `${state.perfumes[0].c} – ${fmt(state.perfumes[0].p)}` : 'Sin elegir';
    if (sumP2) sumP2.textContent = state.perfumes[1] ? `${state.perfumes[1].c} – ${fmt(state.perfumes[1].p)}` : 'Sin elegir';
    const perfumesTotal = state.perfumes.reduce((sum, p) => sum + (p?.p || 0), 0);
    const totalValue = perfumesTotal + state.muestrasValue;
    const set = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
    set('price-perfumes', perfumesTotal > 0 ? fmt(perfumesTotal) : '–');
    set('price-total', perfumesTotal > 0 ? fmt(totalValue) : '–');
    set('price-final', perfumesTotal > 0 ? fmt(perfumesTotal) : '0 €');
    set('sticky-price', perfumesTotal > 0 ? fmt(perfumesTotal) : '0 €');
    const card = $('#summary-card'); if (card) card.classList.toggle('ready', state.perfumes[0] && state.perfumes[1] && state.muestras.length === state.muestrasQty);
  }

  function updateCTA() {
    const isComplete = state.perfumes[0] && state.perfumes[1] && state.muestras.length === state.muestrasQty;
    const btnCta = $('#btn-cta'), ctaStatus = $('#cta-status');
    if (btnCta) { 
      btnCta.disabled = !isComplete; 
      btnCta.textContent = isComplete 
        ? '🎁 Quiero mi pack + ' + state.muestrasValue + '€ gratis' 
        : 'Completar selección'; 
    }
    if (ctaStatus) {
      if (!state.perfumes[0] && !state.perfumes[1]) { ctaStatus.textContent = 'Elige 2 perfumes y tus muestras gratis'; ctaStatus.classList.remove('ready'); }
      else if (!state.perfumes[0] || !state.perfumes[1]) { ctaStatus.textContent = 'Falta 1 perfume'; ctaStatus.classList.remove('ready'); }
      else if (state.muestras.length < state.muestrasQty) { ctaStatus.textContent = `Elige ${state.muestrasQty - state.muestras.length} muestras más`; ctaStatus.classList.remove('ready'); }
      else { ctaStatus.textContent = '✓ ¡Listo! Envío gratis · Entrega garantizada antes del 14'; ctaStatus.classList.add('ready'); }
    }
    const stickyTitle = $('#sticky-title'), stickyBtn = $('#sticky-btn');
    if (stickyTitle) stickyTitle.textContent = isComplete ? '¡Pack listo!' : 'Configura tu pack';
    if (stickyBtn) stickyBtn.textContent = isComplete ? '🎁 Comprar · ' + fmt(state.perfumes.reduce((s,p)=>s+(p?.p||0),0)) : 'Configurar';
    if (isComplete && !state.celebrated) { state.celebrated = true; triggerCelebration(); }
    else if (!isComplete) state.celebrated = false;
    const finalUrgency = $('#final-urgency');
    if (finalUrgency) {
      finalUrgency.style.display = isComplete ? 'flex' : 'none';
}
  }

  function updateAll() { updateProgress(); updateSummary(); updateCTA(); }

  function initStickyCta() {
    const sticky = $('#sticky-cta'), header = $('.sv-header'), summary = $('.sv-summary');
    if (!sticky || !header || !summary) return;
    function check() {
      const headerBottom = header.offsetTop + header.offsetHeight;
      const summaryRect = summary.getBoundingClientRect();
      sticky.classList.toggle('visible', window.scrollY > headerBottom && summaryRect.top > window.innerHeight);
    }
    window.addEventListener('scroll', check, { passive: true }); check();
    const stickyBtn = $('#sticky-btn');
    if (stickyBtn) stickyBtn.onclick = () => {
      const isComplete = state.perfumes[0] && state.perfumes[1] && state.muestras.length === state.muestrasQty;
      if (isComplete) addToCart();
      else $((!state.perfumes[0] || !state.perfumes[1]) ? '#step-perfumes' : '#step-muestras')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
  }

  function triggerCelebration() {
    const container = $('#celebration');
    if (!container) return;
    container.classList.add('active');
    const colors = ['#9e2a3b', '#c9a961', '#f8e8ea', '#4a9e6b', '#fff'];
    for (let i = 0; i < 50; i++) {
      const c = document.createElement('div');
      c.className = 'sv-confetti';
      c.style.cssText = `left:${Math.random()*100}%;background:${colors[Math.floor(Math.random()*colors.length)]};animation:confettiFall ${2+Math.random()*2}s ease-out forwards;animation-delay:${Math.random()*0.5}s;`;
      container.appendChild(c);
    }
    if (!document.getElementById('confetti-styles')) {
      const style = document.createElement('style');
      style.id = 'confetti-styles';
      style.textContent = '@keyframes confettiFall{0%{transform:translateY(-10px) rotate(0);opacity:1}100%{transform:translateY(100vh) rotate(720deg);opacity:0}}';
      document.head.appendChild(style);
    }
    setTimeout(() => { container.innerHTML = ''; container.classList.remove('active'); }, 4000);
    showToast('🎉 ¡Selección completada!');
  }

  function initFaq() { $$('.sv-faq-q').forEach(btn => { btn.onclick = () => { const item = btn.parentElement; const wasOpen = item.classList.contains('open'); $$('.sv-faq-item').forEach(i => i.classList.remove('open')); if (!wasOpen) item.classList.add('open'); }; }); }

  function showToast(msg) { const toast = $('#toast'); if (!toast) return; toast.textContent = msg; toast.classList.add('visible'); setTimeout(() => toast.classList.remove('visible'), 2500); }

  function addToCart() {
    if (!state.perfumes[0] || !state.perfumes[1] || state.muestras.length !== state.muestrasQty) return;
    const muestrasProps = {};
    state.muestras.forEach((m, i) => { muestrasProps[`Muestra ${i + 1}`] = `${m.c} - ${m.i || ''}`; });
    const items = [
      { id: state.perfumes[0].v, quantity: 1, properties: { '_bundle': 'San Valentín 2026', '_posicion': 'Perfume 1' } },
      { id: state.perfumes[1].v, quantity: 1, properties: { '_bundle': 'San Valentín 2026', '_posicion': 'Perfume 2' } },
      { id: CFG.muestrasVariantId || '56352512934212', quantity: 1, properties: muestrasProps }
    ];
    const btnCta = $('#btn-cta'), stickyBtn = $('#sticky-btn'), originalText = btnCta?.textContent || 'Comprar';
    if (btnCta) { btnCta.disabled = true; btnCta.textContent = '⏳ Preparando...'; }
    if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Preparando...'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) })
      .then(res => res.ok ? res.json() : res.json().then(err => { throw err; }))
      .then(() => { showToast('✓ ¡Añadido!'); setTimeout(() => { window.location.href = '/checkout'; }, 500); })
      .catch(err => {
        console.error('Error', err); showToast('Error: ' + (err.description || err.message || 'Inténtalo de nuevo'));
        if (btnCta) { btnCta.disabled = false; btnCta.textContent = originalText; }
        if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = '🎁 Comprar ahora'; }
      });
  }

  function initSearchHandlers() {
    const pSearch = $('#perfume-search'), pResults = $('#perfume-results'), pFilters = $('#perfume-filters');
    let pFilter = null;
    
    if (pSearch) {
      pSearch.oninput = e => { 
        const q = e.target.value; 
        if (q.length >= 1 || pFilter) { 
          renderResults(pResults, search(PERFUMES, q, pFilter), 'perfume', false); 
          pResults.classList.add('active'); 
        } else {
          pResults.classList.remove('active');
        }
      };
      
      pSearch.onfocus = () => { 
        const hasQuery = pSearch.value.length >= 1 || pFilter; 
        renderResults(pResults, hasQuery ? search(PERFUMES, pSearch.value, pFilter) : PERFUMES.slice(0, 15), 'perfume', !hasQuery); 
        pResults.classList.add('active'); 
      };
    }
    
    if (pFilters) {
      pFilters.onclick = e => {
        const chip = e.target.closest('.sv-filter'); 
        if (!chip) return;
        if (pFilter === chip.dataset.filter) { 
          pFilter = null; 
          chip.classList.remove('active'); 
        } else { 
          pFilters.querySelectorAll('.sv-filter').forEach(f => f.classList.remove('active')); 
          chip.classList.add('active'); 
          pFilter = chip.dataset.filter; 
        }
        renderResults(pResults, search(PERFUMES, pSearch?.value || '', pFilter), 'perfume', false); 
        pResults.classList.add('active');
      };
    }
    
    if (pResults) {
      pResults.onclick = e => { 
        const item = e.target.closest('.sv-result'); 
        if (!item) return; 
        selectPerfume(item.dataset.code); 
        if (pSearch) pSearch.value = ''; 
        pResults.classList.remove('active'); 
      };
    }
    
    const mSearch = $('#muestra-search'), mResults = $('#muestra-results');
    
    if (mSearch) {
      mSearch.oninput = e => { 
        const q = e.target.value; 
        if (q.length >= 1) { 
          renderResults(mResults, search(MUESTRAS, q, null), 'muestra', false); 
          mResults.classList.add('active'); 
        } else {
          mResults.classList.remove('active');
        }
      };
      
      mSearch.onfocus = () => { 
        const hasQuery = mSearch.value.length >= 1; 
        renderResults(mResults, hasQuery ? search(MUESTRAS, mSearch.value, null) : MUESTRAS.slice(0, 15), 'muestra', !hasQuery); 
        mResults.classList.add('active'); 
      };
    }
    
    if (mResults) {
      mResults.onclick = e => { 
        const item = e.target.closest('.sv-result'); 
        if (!item) return; 
        selectMuestra(item.dataset.code); 
        if (mSearch) mSearch.value = ''; 
        mResults.classList.remove('active'); 
      };
    }
    
    document.addEventListener('click', e => { 
      if (!e.target.closest('#perfume-search-wrap') && pResults) pResults.classList.remove('active'); 
      if (!e.target.closest('#muestra-search-wrap') && mResults) mResults.classList.remove('active'); 
    });
  }

  async function init() {
    const bundle = $('#sv-bundle'); if (!bundle) return;
    const loaded = await loadProducts();
    if (!loaded) { const lt = $('.sv-loading-text'); if (lt) lt.textContent = 'Error. Recarga la página.'; return; }
    bundle.classList.add('loaded'); state.loaded = true;
    initTramoUI(); initSearchHandlers();
    updatePacksDisplay();
    $$('.sv-pack').forEach(btn => { btn.onclick = () => selectPack(btn.dataset.pack); });
    const btnRandom = $('#btn-random'); if (btnRandom) btnRandom.onclick = selectRandomMuestras;
    const btnClear = $('#btn-clear-muestras'); 
    if (btnClear) btnClear.onclick = () => {
      state.muestras = [];
      state.activePack = null;
      updatePackButtons(); renderMuestras(); updateAll();
      showToast('🗑️ Muestras eliminadas');
    };
    const btnCta = $('#btn-cta'); if (btnCta) btnCta.onclick = addToCart;
    initFaq(); setTimeout(initStickyCta, 100);
    renderPerfumes(); renderMuestras(); updateAll();
    // Pre-seleccionar muestras random por defecto
    if (state.muestras.length === 0) {
      const shuffled = [...MUESTRAS].sort(() => Math.random() - 0.5);
      state.muestras = shuffled.slice(0, state.muestrasQty);
      renderMuestras();
      updateAll();
    }
    console.log(`SVBundle v9.1 READY: ${PERFUMES.length} productos, tramo ${state.muestrasQty} muestras`);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


